/*###########################################################################
// Tooltips
//#########################################################################*/

import tippy from 'tippy.js'

const tooltips = {
	config: {
		tooltip: '.tooltip'
	},

	elements: {},

	init(el = document) {
		const self = this

		self.elements.tooltips = el.querySelectorAll(self.config.tooltip)

		if (self.elements.tooltips !== null) {
			for (let i = 0; i < self.elements.tooltips.length; i++) {
				const tooltip = self.elements.tooltips[i]

				self.handleTooltip(tooltip)
			}
		}
	},

	handleTooltip(tooltip) {
		const self = this

		let placement = 'bottom'
		if (tooltip.hasAttribute('data-tippy-placement') && tooltip.getAttribute('data-tippy-placement') !== '') {
			placement = tooltip.getAttribute('data-tippy-placement')
		}

		tippy(tooltip, {
			placement: placement
		})
	}
}

initComponent(() => {
	tooltips.init()
})

window.addEventListener('modalOpen', function(e) {
	tooltips.init(e.modal)
})

